import React from 'react';
import {RangeSlider} from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import Select from 'react-select';
import { Collapse } from 'react-bootstrap';
import {Link} from 'react-router-dom';
import "react-datepicker/dist/react-datepicker.css";
import DateRangePicker from "react-bootstrap-daterangepicker";
import LocationAutocomplete from './LocationAutocomplete';
import SearchableCustomerSelect from "../../Common/SearchableCustomerSelect ";

const Filter = ({
    setOpenMenu, openMenu, propertyTypeOptions, 
    listingTypeOptions, priceRange, areaRange, 
    setPriceRange, setAreaRange, onPlaceSelected, 
    onSubmit, setSearchTerm, setPropertyTypeId, 
    setListingTypeId, setLocation,
    startDate, endDate, setDateRange, report= false, setCustomer,
    availabilityTypeOptions,setAvailabilityTypeId, adStatusOptions, setAdStatusId,
    isFeatured, setIsFeatured, isVerified, setIsVerified
}) => {

    return (
        <div className="row">
            <div className="col-12">
                <div className="filter cm-content-box box-primary">
                    <div className="content-title SlideToolHeader"
                        onClick={() => setOpenMenu(!openMenu)}
                    >
                        <div className="cpa">
                            <i className="fa-sharp fa-solid fa-filter me-2" />Filter
                        </div>
                        <div className="tools">
                            <Link to={"#"} className={`handle ${openMenu ? "expand" : "collpase"}`}>
                                <i className="fal fa-angle-down" />
                            </Link>
                        </div>
                    </div>
                    <Collapse in={openMenu}>
                        <div className="cm-content-body form excerpt">
                            <div className="card-body">
                                <form>
                                    <div className="row">
                                        <div className="mb-3 col-lg-3 col-md-6">
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Enter Your Keyword..." 
                                                required="" 
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />
                                        </div>
                                        <div className="mb-3 col-lg-3 col-md-6">
                                            <LocationAutocomplete
                                                onPlaceSelected={onPlaceSelected}
                                                onCleared={() => setLocation({ latitude: '', longitude: '' })}
                                                triggerInit={true}
                                            />
                                        </div>
                                        <div className="mb-3 col-lg-3 col-md-6">
                                            <Select
                                                options={propertyTypeOptions}
                                                // defaultValue={type[0]}
                                                className="custom-react-select"
                                                isSearchable={false}
                                                isClearable={true}
                                                placeholder="Select Property Type"
                                                onChange={(selected) => {
                                                    setPropertyTypeId(selected?.value);
                                                }}
                                                styles={{
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 99
                                                    }),
                                                    menuPortal: (provided) => ({
                                                        ...provided,
                                                        zIndex: 99
                                                    })
                                                }}
                                                menuPortalTarget={document.body}
                                            />

                                        </div>
                                        <div className="mb-3 col-lg-3 col-md-6">
                                            <Select
                                                options={listingTypeOptions}
                                                // defaultValue={Rent[0]}
                                                className="custom-react-select"
                                                isSearchable={false}
                                                isClearable={true}
                                                placeholder="Select Listing Type"
                                                onChange={(selected) => {
                                                    setListingTypeId(selected?.value);
                                                }}
                                                styles={{
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 99
                                                    }),
                                                    menuPortal: (provided) => ({
                                                        ...provided,
                                                        zIndex: 99
                                                    })
                                                }}
                                                menuPortalTarget={document.body}
                                            />
                                        </div>
                                    </div>
                                </form>
                                <div className="row align-items-center">
                                    {report && (
                                        <>
                                            <div className="mb-3 col-lg-3 col-md-6">
                                                {/* <h6 className="title">Date Range</h6> */}
                                                <div className="input-group">
                                                    <DateRangePicker
                                                    initialSettings={{
                                                        startDate: startDate,
                                                        endDate: endDate,
                                                        locale: {
                                                            format: 'DD/MM/YYYY',
                                                        },
                                                    }}
                                                    onApply={(event, picker) => {
                                                        setDateRange({
                                                        startDate: picker.startDate,
                                                        endDate: picker.endDate,
                                                        });
                                                    }}
                                                    >
                                                    <input
                                                        type="text"
                                                        className="form-control input-daterange-timepicker"
                                                        placeholder="Select date range"
                                                        readOnly
                                                        value={
                                                        startDate && endDate
                                                            ? `${startDate.format('DD/MM/YYYY')} - ${endDate.format('DD/MM/YYYY')}`
                                                            : ''
                                                        }
                                                    />
                                                    </DateRangePicker>
                                                </div>
                                            </div>
                                            <div className="mb-3 col-lg-3 col-md-6">
                                                <SearchableCustomerSelect onSelect={(option) => setCustomer(option?.value)} />
                                            </div>
                                            <div className="mb-3 col-lg-3 col-md-6">
                                                <Select
                                                    options={availabilityTypeOptions}
                                                    // defaultValue={type[0]}
                                                    className="custom-react-select"
                                                    isSearchable={false}
                                                    isClearable={true}
                                                    placeholder="Select Availability Status"
                                                    onChange={(selected) => {
                                                        setAvailabilityTypeId(selected?.value);
                                                    }}
                                                    styles={{
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            zIndex: 99
                                                        }),
                                                        menuPortal: (provided) => ({
                                                            ...provided,
                                                            zIndex: 99
                                                        })
                                                    }}
                                                    menuPortalTarget={document.body}
                                                />
                                            </div>
                                            <div className="mb-3 col-lg-3 col-md-6">
                                                <Select
                                                    options={adStatusOptions}
                                                    // defaultValue={type[0]}
                                                    className="custom-react-select"
                                                    isSearchable={false}
                                                    isClearable={true}
                                                    placeholder="Select Ad Status"
                                                    onChange={(selected) => {
                                                        setAdStatusId(selected?.value);
                                                    }}
                                                    styles={{
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            zIndex: 99
                                                        }),
                                                        menuPortal: (provided) => ({
                                                            ...provided,
                                                            zIndex: 99
                                                        })
                                                    }}
                                                    menuPortalTarget={document.body}
                                                />
                                            </div>
                                        </>
                                    )}
                                    <div className="mb-3 col-lg-3 col-md-6">
                                        <h6 className="title">Price Range</h6>
                                        <div className="combined2 mt-3">
                                            <RangeSlider
                                                min={0}
                                                max={10000000}
                                                step={1000}
                                                tooltip={false}
                                                className='combined-slider mb-3'
                                                progress
                                                value={priceRange}
                                                onChange={value => {
                                                    setPriceRange(value);
                                                }}
                                            />
                                            <span className="example-val" id="slider-combined2-value-min">
                                                {priceRange[0]} 
                                            </span>
                                            {" "} to {" "}
                                            <span className="example-val" id="slider-combined2-value-max">
                                                {priceRange[1]}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="mb-3 col-lg-3 col-md-6">
                                        <h6 className="title">Area Range</h6>
                                        <div className="combined mt-3">
                                            <RangeSlider
                                                min={0}
                                                max={1000}
                                                step={1}
                                                tooltip={false}
                                                className="combined-slider mb-3"
                                                progress
                                                value={[0, areaRange[1]]}
                                                onChange={([_, upper]) => {
                                                    setAreaRange([0, upper]);
                                                }}
                                            />
                                            <span className="example-val" id="slider-combined2-value-min">
                                                {areaRange[0]}
                                            </span>
                                            {" "} to {" "}
                                            <span className="example-val" id="slider-combined2-value-max">
                                                {areaRange[1]}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 align-self-end mb-3">
                                        <div className="form-check custom-checkbox mb-3 checkbox-primary">
                                            <input
                                                // checked={false}
                                                type="checkbox"
                                                className="form-check-input"
                                                id="customCheckBox5"
                                                checked={isFeatured}
                                                onChange={(e) => setIsFeatured(e.target.checked)}
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor="customCheckBox5"
                                            >
                                                Featured
                                            </label>
                                        </div>
                                        <div className="form-check custom-checkbox mb-3 checkbox-primary">
                                            <input
                                                // checked={false}
                                                type="checkbox"
                                                className="form-check-input"
                                                id="customCheckBox5"
                                                checked={isVerified}
                                                onChange={(e) => setIsVerified(e.target.checked)}
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor="customCheckBox5"
                                            >
                                                Verified
                                            </label>
                                        </div>       
                                    </div>
                                    <div className="col-lg-3 col-md-6 align-self-end mb-3">
                                        <button onClick={onSubmit} className="btn btn-primary rounded-sm w-100" title="Click here to Search" type="button">
                                            <i className="fa fa-search me-1" />Search
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Collapse>
                </div>
            </div>
        </div>
    );
};


export default Filter;